<template>
  <v-btn
    x-small
    text
    icon
    class="ma-0 pa-0"
    @click.stop="onClick"
    :disabled="disabled"
  >
    <v-icon v-if="!state || state === 'default'">mdi-play-outline</v-icon>
    <v-progress-circular
      v-else-if="state === 'running'"
      indeterminate
      color="accent"
      :size="17"
      :width="2"
    />
    <v-icon v-else-if="state === 'waiting'">
      mdi-timer-sand
    </v-icon>
    <v-icon v-else-if="state === 'success'" color="success">
      check_circle
    </v-icon>
    <v-icon v-else-if="state === 'fail'" color="error">
      error
    </v-icon>
    <v-icon v-else-if="state === 'warning'" color="warning">
      warning
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "ProcessingButton",

  props: {
    state: {
      type: String,
      required: true
    },

    playIsDisable: {
      type: Boolean
    }
  },

  computed: {
    disabled() {
      if (this.state === "running" || this.state === "waiting") {
        return true;
      } else if (!this.state || this.state === "default") {
        return this.playIsDisable;
      }
    }
  },

  methods: {
    onClick() {
      if (this.state === "success" || this.state === "fail") {
        this.$emit("change-to-default");
      } else if (this.state === "default") {
        this.$emit("run-processing");
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/Processing/ProcessingButton.vue